export const Regions = {
  UK: 'UK',
  US: 'US',
  CAN_MEX: 'CAN-MEX',
  EU_1: 'EU1',
  EU_2: 'EU2',
  M_EAST: 'MEAST',
  A_PAC: 'APAC',
  /**
   * Rest of the world.
   */
  ROW: 'ROW',
} as const

export const RegionToCountriesMap = {
  [Regions.UK]: ['UK', 'GB', 'GG', 'JE'],
  [Regions.US]: ['US'],
  [Regions.CAN_MEX]: ['CA', 'MX'],
  [Regions.EU_1]: [
    'BE',
    'DE',
    'FR',
    'IE',
    'LU',
    'MC',
    'NL',
    'ES',
    'IT',
    'PT',
    'SM',
    'VA',
    'CH',
  ],
  [Regions.EU_2]: [
    'BG',
    'CZ',
    'EE',
    'GI',
    'HR',
    'HU',
    'LT',
    'LV',
    'PL',
    'RO',
    'SI',
    'SK',
    'AL',
    'BA',
    'KV',
    'ME',
    'MK',
    'RS',
    'AD',
    'AT',
    'CY',
    'DK',
    'MT',
    'FI',
    'GR',
    'SE',
    'FO',
    'GL',
    'IC',
    'IS',
    'LI',
    'NO',
  ],
  [Regions.M_EAST]: ['IL', 'TR', 'AE', 'BH', 'JO', 'KW', 'OM', 'QA', 'SA'],
  [Regions.A_PAC]: [
    'JP',
    'KR',
    'HK',
    'SG',
    'CN',
    'TW',
    'AG',
    'AI',
    'AW',
    'BB',
    'BM',
    'BS',
    'CU',
    'DM',
    'DO',
    'GD',
    'GP',
    'HT',
    'JM',
    'KN',
    'KY',
    'LC',
    'MQ',
    'MS',
    'TC',
    'TT',
    'VC',
    'XB',
    'XC',
    'XE',
    'XM',
    'XN',
    'XY',
    'AU',
    'NZ',
  ],
  [Regions.ROW]: [
    'BI',
    'CD',
    'CF',
    'CG',
    'CI',
    'CM',
    'CV',
    'DJ',
    'ER',
    'ET',
    'GA',
    'GH',
    'GM',
    'GN',
    'GQ',
    'GW',
    'KE',
    'KM',
    'LR',
    'LS',
    'LY',
    'MA',
    'MG',
    'ML',
    'MR',
    'MU',
    'MW',
    'MZ',
    'NA',
    'NE',
    'NG',
    'RE',
    'RU',
    'RW',
    'SC',
    'SD',
    'SH',
    'SL',
    'SN',
    'SO',
    'SS',
    'ST',
    'SZ',
    'TD',
    'TG',
    'TN',
    'TZ',
    'UG',
    'XS',
    'YT',
    'ZA',
    'ZM',
    'ZW',
    'AO',
    'BF',
    'BJ',
    'BW',
    'DZ',
    'AF',
    'AZ',
    'GE',
    'IQ',
    'IR',
    'KG',
    'KZ',
    'TJ',
    'TM',
    'UZ',
    'BY',
    'BN',
    'BT',
    'KH',
    'LA',
    'MM',
    'NP',
    'CK',
    'FJ',
    'KI',
    'KP',
    'MN',
    'MV',
    'NC',
    'NR',
    'NU',
    'PF',
    'PG',
    'SB',
    'TL',
    'TO',
    'TV',
    'VU',
    'WS',
    'MD',
    'UA',
    'AR',
    'BO',
    'BR',
    'BZ',
    'CL',
    'CO',
    'CR',
    'EC',
    'FK',
    'GF',
    'GT',
    'HN',
    'NI',
    'PA',
    'PE',
    'PY',
    'SR',
    'SV',
    'UY',
    'VE',
    'AM',
    'LB',
    'SY',
    'YE',
    'EG',
    'BD',
    'ID',
    'PH',
    'LK',
    'PK',
    'VN',
    'IN',
    'MO',
    'MY',
    'TH',
  ],
}
